<template>
  <a
    class="colorBlack navLink u-full-width"
    @click="showShippingOrder(shippingOrder.shipping_order_id)"
  >
    <div class="dropdownLeadImageContainer">
      <img v-lazy="shippingOrder.card.image">
    </div>
    <div>
      <div v-html="shippingOrder.card.title" />
    </div>
  </a>
</template>

<script>

export default {
	name: 'ShippingOrderCard',
	components: {
	},
	props: [
		'shipping_order_id'
	],
	data () {
		return {
		}
	},
	computed: {

		shippingOrders: function () {
			return this.$store.getters.shippingOrders
		},

		shippingOrder: function () {
			return this.shippingOrders['SHIPPINGORDERID_' + this.shipping_order_id]
		}
	},
	methods: {

		showShippingOrder (payload) {
			if (this.shippingOrder.status === 'PAYMENT_REQUIRED') {
				this.$store.dispatch('updateCurrentInvoice', this.shippingOrder.invoice_id)
				this.$store.dispatch('insertAccountHistory', 'Invoice')
			} else {
				this.$store.dispatch('updateCurrentShippingOrder', payload)
				this.$store.dispatch('insertAccountHistory', 'Shipping Order')
			}
		},

	}
}

</script>

<style scoped>

</style>
